import { environment } from '@employer/environments/environment'
import Rollbar from 'rollbar' // ES6 import syntax needs "esModuleInterop": true in tsconfig.json

// Rollbar treats a configured scrubFields as a replacement for its defaults, so the browser defaults
// (rollbar/src/defaults.js + src/browser/defaults.js) are restated here before our additions.
const ROLLBAR_DEFAULT_SCRUB_FIELDS = [
  'pw', 'pass', 'passwd', 'password', 'secret', 'confirm_password', 'confirmPassword', 'password_confirmation',
  'passwordConfirmation', 'access_token', 'accessToken', 'X-Rollbar-Access-Token', 'secret_key', 'secretKey', 'secretToken',
  'cc-number', 'card number', 'cardnumber', 'cardnum', 'ccnum', 'ccnumber', 'cc num', 'creditcardnumber', 'credit card number',
  'newcreditcardnumber', 'new credit card', 'creditcardno', 'credit card no', 'card#', 'card #', 'cc-csc', 'cvc', 'cvc2', 'cvv2',
  'ccv2', 'security code', 'card verification', 'name on credit card', 'name on card', 'nameoncard', 'cardholder', 'card holder',
  'name des karteninhabers', 'ccname', 'card type', 'cardtype', 'cc type', 'cctype', 'payment type', 'expiration date',
  'expirationdate', 'expdate', 'cc-exp', 'ccmonth', 'ccyear',
]

export const rollbarConfig: Rollbar.Configuration = {
  enabled: environment.env !== 'dev', // Don't emit when developing on local
  accessToken: 'e9b129b51df94b79a81c786a6769dfe9',
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubFields: [...ROLLBAR_DEFAULT_SCRUB_FIELDS, 'code', 'token'],
  recorder: {
    enabled: true,
    maskInputOptions: {
      password: true,
      email: true,
    },
  },
  payload: {
    environment: environment.env,
    server: {
      root: 'webpack:///./',
    },
    client: {
      javascript: {
        source_map_enabled: true, // true by default

        // -- Add this into your configuration ---
        code_version: 'b133d5678fb84cf45076de93401a0446feb4b171',
        // ---------------------------------------

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig)
}
